import { type EventTypeEnum } from '@clubspark-node/clubspark-tennis-types';

export interface Option {
  label: string;
  value: string;
}

export interface FormData {
  listType: string;
  format: string;
  publishDate: string;
  formatType: string;
}

export enum ScaleTypeEnum {
  RATING = 'RATING',
  RANKING = 'RANKING',
}

export enum ListTypeEnum {
  STANDING = 'STANDING',
  SEEDING = 'SEEDING',
}

export type FormatType = 'COMBINED' | 'INDIVIDUAL' | 'TEAM' | '';

export enum RatingTypeEnum {
  NTRP = 'NTRP',
  WTN = 'WTN',
  PT = 'PT',
}

export interface ScaleAttributes {
  scaleName: string;
  scaleType: ScaleTypeEnum;
  eventType: EventTypeEnum;
}
